import { getEnumValues } from './get-enum-values';
export enum DominantSide {
    Left = 'left',
    Right = 'right',
    Ambidextrous = 'ambidextrous',
}
export const DominantSideValues = getEnumValues<DominantSide>(DominantSide);